const Treatment = () => import(/* webpackPrefetch: true, webpackChunkName: "treatment-component" */ '@/app/views/main-view/_shared/_components/treatment-component/treatment-component.vue');

export default {
    name: 'TreatmentContainer',
    components: {
        Treatment
    }
}